import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-account-index',
    templateUrl: './account-index.component.html',
    styleUrls: ['./account-index.component.scss'],
    standalone: true,
    imports: [RouterOutlet]
})
export class AccountIndexComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
